var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ota-app"},[(_vm.showHeader)?_c('header-navigation',{attrs:{"logo":false,"hide-header":!_vm.isBw && _vm.showHeader}}):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.reloadKey,on:{"changeLocale":_vm.changeLocale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }